export const version = "1.0.2-daily-20260407-0";
export const channel = "daily";
export const gitcommit = "2dc3570d8";
